import { noop } from 'lodash'
import React from 'react'
import { Container } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'

import { FieldPrefix } from '../../Field'
import LoaderOverlay from '../../LoaderOverlay'
import FilterLabel from '../FilterLabel'
import FilterWrapperNew from '../FilterWrapperNew'
import InfinityTable from '../index'
import { IField, ListContainerProps } from '../types'

const ContainerWrapper = styled(Container)`
  @media (min-width: 1200px) {
    max-width: 2200px;
  }
  flex: 1;
  display: flex;
  flex-direction: column;
  align-self: center;
  position: relative;
  margin: 0 -12px;
`

const ListContainer = (props: ListContainerProps): React.ReactElement => {
  const {
    items,
    totalCount,
    request,
    saveUi,
    ui,
    applyFilter,
    sort,
    setSort,
    sortableColumns,
    columns,
    mobileColumn,
    topMarginOrder,
    fullWidth,
    zeroPaddings = false,
    hideDetail = false,
    fallBackDeleteFilter = undefined,
    noTopMargin,
    zeroInnerPaddings,
    isLoading,
    selectIsCrudLoading,
    height = 'auto',
    setFilter = noop,
    filter,
    filterClean,
    filterLabelVariant = 'info',
    minWidthMobileToggle = 760,
    filterForm,
    applyLocalFilter,
    useLocalStateFiltering,
    noFilters,
    customFilterBarElement,
    customHeaderComponent,
    ...rest
  } = props

  const isMobile = useMediaQuery({
    query: `(max-width: ${minWidthMobileToggle}px)`,
  })

  const removeFilter = (field: string, type: string): void => {
    setFilter({
      name: field,
      value: type === 'threeSidedBoolean' ? 'unrestricted' : '',
    })

    if (applyFilter) {
      applyFilter({ reset: { reset: false } })
    }
  }

  return (
    <FieldPrefix prefix="">
      <ContainerWrapper
        fluid={zeroPaddings || false}
        style={{
          flex: 'auto',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: fullWidth ? '100%' : '',
          padding: zeroInnerPaddings ? 0 : '0 12px',
          height: height,
        }}
        className={noTopMargin ? '' : topMarginOrder ? 'mt-4' : 'mt-2'}
      >
        <LoaderOverlay
          isLoading={isLoading || selectIsCrudLoading}
          fullscreen
        />
        {customHeaderComponent}
        {!noFilters && (
          <>
            <FilterWrapperNew
              applyFilter={applyFilter}
              useLocalStateFiltering={useLocalStateFiltering}
              setFilter={setFilter}
              filterClean={filterClean}
              ui={ui}
              saveUi={saveUi}
              zeroInnerPaddings={zeroInnerPaddings}
              filter={filter}
              filterForm={filterForm}
              applyLocalFilter={applyLocalFilter}
              isMobile={isMobile}
              topMarginOrder={topMarginOrder}
              fullWidth={fullWidth}
              zeroPaddings={zeroPaddings}
              hideDetail={hideDetail}
              fallBackDeleteFilter={fallBackDeleteFilter as IField[]}
              customFilterBarElement={customFilterBarElement}
            ></FilterWrapperNew>
            <div>
              {!isLoading && (
                <FilterLabel
                  filter={filter}
                  ui={ui}
                  filterClean={filterClean}
                  filterLabelVariant={filterLabelVariant}
                  removeFilter={removeFilter}
                />
              )}
            </div>
          </>
        )}

        <div
          className={`mb-2 card ${zeroPaddings ? 'p-0' : 'p-2'} flex-fill`}
          style={{ flex: 1 }}
        >
          <InfinityTable
            items={items}
            totalItemCount={totalCount}
            columns={columns}
            request={request}
            saveUi={saveUi}
            ui={ui}
            customRowDataKey=""
            rowHeight={props.rowHeight || 60}
            sorts={sort}
            applyFilter={applyFilter}
            setSort={setSort}
            sortableColumns={sortableColumns}
            mobileColumn={mobileColumn}
            renderMobile={isMobile}
            setFilter={setFilter}
            filter={filter}
            filterClean={filterClean}
            useLocalStateFiltering={useLocalStateFiltering}
            {...rest}
          />
        </div>
      </ContainerWrapper>
    </FieldPrefix>
  )
}

export default ListContainer
